module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Aquarium-a18c6a31c23e79c1746d2baa6066050e.png";